import { Button } from '../design-system';
import React from 'react';
import { useTheme } from 'styled-components';

interface ButtonCellColumnProps {
  onClick: () => void;
  leftIcon: React.ElementType;
}

const ButtonCellColumn = ({ onClick, leftIcon }: ButtonCellColumnProps) => {
  const theme = useTheme();
  return (
    <Button
      onClick={onClick}
      leftIcon={leftIcon}
      variant="transparent"
      leftIconProps={{ size: 20, color: theme.colors.primary }}
    />
  );
};

export default ButtonCellColumn;
